import RevAudTable from "src/components/pages/Summary/ReviewsAndAudits/RevAudTable";
import useGetRevAud from "src/components/pages/Summary/ReviewsAndAudits/useGetRevAud";

interface Props {
  isAudit?: boolean;
}

const ReviewsAndAudits = ({ isAudit }: Props) => {
  const request = isAudit ? "get-reviews-flags" : "get-reviews";
  const { data, isLoading, refetch } = useGetRevAud(request);

  return (
    <div style={{ paddingTop: 20 }}>
      {/* <Flex align="center" justify="space-between" p={9}> */}
      {/*   <Text size="xl">{isReview ? "RevAndAud" : "Audits"}</Text> */}
      {/*   <Button onClick={handleToggleRequest} variant="outline"> */}
      {/*     Show {isReview ? "Audits" : "RevAndAud"} */}
      {/*   </Button> */}
      {/* </Flex> */}

      <RevAudTable
        data={data ?? []}
        refetch={refetch}
        loading={isLoading}
        reviewerCell={{ label: `${isAudit ? "Auditor" : "Reviewer"} Name` }}
      />
    </div>
  );
};
export default ReviewsAndAudits;
